(function (app, core) {
    'use strict';

    const MENU_SCROLL_LIMIT = 50;
    const MENU_SCROLL_TRANSPARENT = 20;

    app.MainNavigation = function (container) {
        const _self = this;
        _self.container = container;
        _self.subMenuNavContainer =
            _self.container.querySelector('.js-container');
        _self.subMenuItemContainer =
            _self.container.querySelectorAll('.js-item');
        _self.subMenuItem = _self.container.querySelectorAll('.js-sub-item');
        _self.menuOpen = _self.container.querySelector('.js-menu-open');
        _self.sidebarOpen = _self.container.querySelector('.js-sidebar-open');
        _self.body = document.querySelector('body');
        _self.mainContent = document.querySelector('.main-content');
        _self.isVideo = document.querySelector('.video-hero');
        _self.heroContentHeight = _self.container.offsetHeight;
        _self.isVideo === null
            ? (_self.mainContent.style.paddingTop =
                  _self.heroContentHeight + 'px')
            : '';
        _self.setListeners();
    };

    /**
     * Set the listeners for main menu & sidebar menu
     */
    app.MainNavigation.prototype.setListeners = function () {
        const _self = this;
        const bodyColor = _self.container.dataset.eventCode;

        _self.subMenuItemContainer.forEach((item) => {
            if (core.style.hasClass(item, 'is-active')) {
                const offsetLeft = item.offsetLeft;
                _self.subMenuNavContainer.scrollTo({
                    top: 0,
                    left: offsetLeft,
                    behavior: 'smooth'
                });
            }
        });

        _self.subMenuItem.forEach((item) => {
            bodyColor !== '' ? item.classList.add(bodyColor) : null;
        });

        bodyColor !== '' ? core.style.addClass(_self.body, bodyColor) : null;

        const toggleContainer = (className) => {
            core.style.toggleClass(_self.container, className);
            core.style.removeClass(
                _self.container,
                className === 'isMainVisible'
                    ? 'isSidebarVisible'
                    : 'isMainVisible'
            );
        };

        if (_self.menuOpen) {
            _self.menuOpen.addEventListener('click', () =>
                toggleContainer('isMainVisible')
            );
        }
        if (_self.sidebarOpen) {
            _self.sidebarOpen.addEventListener('click', () =>
                toggleContainer('isSidebarVisible')
            );
        }
        _self.stickyNav();
    };

    /**
     * Set the window scroll listener for sticky main menu & event submenu
     */
    app.MainNavigation.prototype.stickyNav = function () {
        const _self = this;
        let lastScrollTop = MENU_SCROLL_LIMIT;

        window.addEventListener(
            'scroll',
            () => {
                const topScroll =
                    window.pageYOffset || document.documentElement.scrollTop;
                const isVisible = _self.container.matches(
                    '.isSidebarVisible, .isMainVisible'
                );
                const isTransparent = _self.container.matches('.isTransparent');

                if (!isVisible) {
                    if (topScroll > lastScrollTop) {
                        core.style.addClass(_self.container, 'isSticky');
                    } else {
                        core.style.removeClass(_self.container, 'isSticky');
                    }
                    lastScrollTop =
                        topScroll <= MENU_SCROLL_LIMIT
                            ? MENU_SCROLL_LIMIT
                            : topScroll;
                }

                if (isTransparent) {
                    if (topScroll > MENU_SCROLL_TRANSPARENT) {
                        core.style.addClass(_self.container, 'isScrolling');
                    } else {
                        core.style.removeClass(_self.container, 'isScrolling');
                    }
                }
            },
            false
        );
    };

    let widgets = document.querySelectorAll('[data-widget="main-navigation"]');

    Array.prototype.forEach.call(widgets, function (widget) {
        new app.MainNavigation(widget);
    });
})(PULSE.app, PULSE.core, PULSE.ui);
